import { Typography, useMediaQuery, useTheme } from '@mui/material'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { StyledScheduleDialogDay } from '../../styles/ScheduleViewStyles'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import { getCurrentMode } from '../../store/redux/reducers/darkModeSlice'
import { BeeCrewGrey } from '../../styles/theme-configuration'

const ScheduleDialogDaysSelector = ({
  dayIndicator,
  repeatOption,
  setSelectedDaysOptions,
}: {
  dayIndicator: number
  repeatOption: string
  setSelectedDaysOptions: Dispatch<SetStateAction<number[]>>
}) => {
  const [isSelected, setIsSelected] = useState(false)

  const theme = useTheme()

  const handleClick = () => {
    setIsSelected(!isSelected)
    setSelectedDaysOptions(prevSelectedDaysOptions => {
      if (prevSelectedDaysOptions.includes(dayIndicator)) {
        return prevSelectedDaysOptions.filter(day => day !== dayIndicator)
      } else {
        return [...prevSelectedDaysOptions, dayIndicator]
      }
    })
  }

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  useEffect(() => {
    if (repeatOption === 'Selected') {
      setIsSelected(false)
    } else if (repeatOption === 'Everyday') {
      setIsSelected(true)
    }
  }, [repeatOption])

  const dayAbbreviation = dayjs().day(dayIndicator).format('dd')

  const mode = useSelector(getCurrentMode)

  const darkModeStyles = {
    backgroundColor: isSelected ? 'primary.main' : BeeCrewGrey[700],
    color: isSelected ? 'black' : BeeCrewGrey[100],
    '&:hover': {
      backgroundColor: isSelected ? 'primary.hover' : BeeCrewGrey[500],
    },
  }

  const lightModeStyles = {
    backgroundColor: isSelected ? 'primary.main' : BeeCrewGrey[200],
    color: isSelected ? 'black' : BeeCrewGrey[950],
    '&:hover': {
      backgroundColor: isSelected ? 'primary.hover' : BeeCrewGrey[100],
    },
  }

  const styles = mode === 'light' ? lightModeStyles : darkModeStyles

  const handleEnterPress = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter') handleClick()
  }

  return (
    <StyledScheduleDialogDay
      value={dayAbbreviation}
      sx={{ ...styles, padding: isSmallScreen ? '20px' : '14px' }}
      onClick={handleClick}
      onKeyDown={handleEnterPress}
    >
      <Typography fontSize={12}>{dayAbbreviation}</Typography>
    </StyledScheduleDialogDay>
  )
}

export default ScheduleDialogDaysSelector
